fx.ns("models", class PhotoFilter extends fx.Model {

	constructor(data)
	{
		super(data);
	}

    get propertiesNotStorable()
    {
        return ["id"];
    }
});